<template>
  <div class="bg-white">
    <router-view></router-view>
    <loading v-model:active="isCallingApi" :is-full-page="isLoadingFullPage"></loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EmptyLayout',
  computed: {
    ...mapGetters(['isCallingApi', 'isLoadingFullPage']),
  },
}
</script>

<style scoped>

</style>
